import { FC } from 'react';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { ButtonIwTextStyled } from '@/_pages/interwill/components/ParticipantContent/styled';
import { useNotices } from '@/features/notices/useNotices';
import { breakpoints, Input, media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { copy } from '@/shared/utils/misc';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { InvitationSuccessModalProps } from '@/widgets/modals/types';

import { ModalContainerV1 } from '../../interwill/containers/ModalContainerV1';

export const InvitationSuccessModal: FC<InvitationSuccessModalProps> = ({
  sentEmail,
  invitationLink,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'invitationSuccess' });
  const notices = useNotices();
  const { closeModal } = useModalsStore();

  const handleCopyLink = async () => {
    await copy(invitationLink);
    notices.success(t('linkCopiedMessage'));
  };

  return (
    <ModalContainerV1 title={t('title', { email: sentEmail })}>
      <SuccessContent>
        <InfoText>{t.rich(invitationLink ? 'infoNew' : 'infoExists')}</InfoText>

        {invitationLink && (
          <>
            <LinkSection>
              <InputStyled value={invitationLink} readOnly />
              <ButtonIwTextStyled
                onClick={handleCopyLink}
                icon={<Icon name="copy-simple" size="s20" />}
              >
                {t('copyBtn')}
              </ButtonIwTextStyled>
            </LinkSection>
            <ManualText>{t('manualInstructions')}</ManualText>
          </>
        )}

        <DoneButtonContainer>
          <ButtonIw onClick={closeModal}>{t('doneBtn')}</ButtonIw>
        </DoneButtonContainer>
      </SuccessContent>
    </ModalContainerV1>
  );
};

const SuccessContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  font-size: 14px;
  height: 100%;

  ${media.md}, ${breakpoints.sm} {
    padding: 0 16px 16px;
  }
`;

const InfoText = styled.span`
  color: ${COLORS.systemDark300};
`;

const LinkSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const ManualText = styled.span`
  margin-top: -12px;
`;

const DoneButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  ${media.md}, ${breakpoints.sm} {
    flex-direction: column;
    margin-top: auto;
  }
`;

const InputStyled = styled(Input)`
  &&& {
    border: none;
    background: ${COLORS.systemLight200};
  }
`;
